import React from 'react';
import { Form, Input, Button, Icon } from 'antd';
import { Contact } from '../../../../models';


let ContactForm = (props) => {
    const { form, contact } = props;
    const { getFieldDecorator } = form;
    const validations = Contact.validations;


    const onSubmit = (e) => {
        e.preventDefault();
        form.validateFields((err, values) => {
			if (err) return;
            props.onSubmit(form.getFieldsValue());
        });
    };


    return (
        <Form onSubmit={onSubmit}>
            {getFieldDecorator("id", {
                initialValue: contact.uuid,
                rules: validations.uuid
            })(<Input autoComplete='off' hidden />)}

            <Form.Item label="Name">
                {getFieldDecorator("name", {
                    initialValue: contact.name,
                    rules: validations.name
                })(<Input autoComplete='off' prefix={<Icon type="profile" />} />)}
            </Form.Item>

            <Form.Item label="Email ID">
                {getFieldDecorator("email", {
                    initialValue: contact.email,
                    rules: validations.email
                })(<Input autoComplete='off' prefix={<Icon type="mail" />} />)}
            </Form.Item>

            <Form.Item label="Phone No.">
                {getFieldDecorator("phone", {
                    initialValue: contact.phone,
                    rules: validations.phone
                })(<Input autoComplete='off' prefix={<Icon type="phone" />} />)}
            </Form.Item>
            
            <div className="w-100 d-flex justify-content-end mt-4">
                <Button type="primary" htmlType="submit" loading={props.loading}>{props.contact.is_edit ? "Update" : "Create"}</Button>
            </div>
        </Form>
    )
};

ContactForm = Form.create()(ContactForm);
export { ContactForm };